import { render, staticRenderFns } from "./DetailBeta.vue?vue&type=template&id=76abd464&scoped=true&"
import script from "./DetailBeta.vue?vue&type=script&lang=js&"
export * from "./DetailBeta.vue?vue&type=script&lang=js&"
import style0 from "./DetailBeta.vue?vue&type=style&index=0&id=76abd464&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76abd464",
  null
  
)

export default component.exports